import { render, staticRenderFns } from "./CorperativesReg.vue?vue&type=template&id=d0cc5636&"
import script from "./CorperativesReg.vue?vue&type=script&lang=js&"
export * from "./CorperativesReg.vue?vue&type=script&lang=js&"
import style0 from "./CorperativesReg.vue?vue&type=style&index=0&id=d0cc5636&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports